import React, { FunctionComponent, useEffect } from 'react'
import styled from 'styled-components'
import cross from '../../../images/cross.svg'
import theme from '../../styling/theme'
import MainGrid from '../../styling/MainGrid'
import img from '../../../images/lady_laptop.svg'
import RequestCallBackForm from '../Form/RequestCallBackForm'
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock'

interface RequestCallBackModalProps {
  showModal: boolean
  toggleModal(state: boolean): void
  type: string
  body: string
}

const RequestCallBackModal: FunctionComponent<RequestCallBackModalProps> = ({
  children,
  showModal,
  toggleModal,
  type,
}) => {
  useEffect(() => {
    if (showModal) {
      const scrollable = document.getElementById('request-a-call-back-modal')
      const body = document.querySelector('body')

      disableBodyScroll(scrollable)

      return () => {
        enableBodyScroll(body)
        clearAllBodyScrollLocks()
      }
    }
  }, [showModal])
  return (
    <OuterContainer showModal={showModal} onClick={() => toggleModal(false)}>
      <Modal onClick={e => e.stopPropagation()} id="request-a-call-back-modal">
        <Top>
          <Inner>
            <p className="p-large">{type}</p>
            <Cross src={cross} onClick={() => toggleModal(false)} />
            <Closebtn onClick={() => toggleModal(false)}>Close</Closebtn>
          </Inner>
        </Top>
        <MainGrid>
          <Content>
            <Col>
              <h3>Request a call back from our experts</h3>
              <p className="p-large">
                To request a call back at any time, one of our team will respond
                to you as soon as possible.
              </p>
              <ImgMask>
                <img src={img} alt="Woman at a desk with a laptop" />
              </ImgMask>
            </Col>
            <Col>
              <RequestCallBackForm />
            </Col>
          </Content>
        </MainGrid>
      </Modal>
    </OuterContainer>
  )
}

export default RequestCallBackModal

const Cross = styled.img`
  cursor: pointer;
  width: 20px;

  @media (min-width: 1024px) {
    display: none;
  }
`

const Closebtn = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    width: 90px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${theme.brand.blue};
    background: white;
    color: ${theme.brand.blue};
    font-weight: bold;
    font-size: 13px;
    line-height: 15px;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background: ${theme.brand.blue};
      color: white;
    }
  }
`

interface OuterContainerProps {
  showModal: boolean
}

const OuterContainer = styled.div<OuterContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: ${props => (props.showModal ? 'flex' : 'none')};
  align-items: flex-start;
  justify-content: center;
  z-index: 5555;
`

const Modal = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  position: relative;
  width: 100%;
  height: 100%;
  position: relative;

  overflow-y: auto;
`

const Top = styled.div`
  background: white;
  border-bottom: 1px solid #ececec;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
`

const Inner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 27px 20px;

  @media only screen and (min-width: 768px) {
    padding: 3rem 3%;
  }

  & p {
    color: ${theme.text.main};
    font-weight: bold;
  }
`
const Content = styled.div`
  display: flex;
  flex-direction: column-reverse;
  padding: 32px 0 50px;
  @media (min-width: 1024px) {
    flex-direction: row;
    padding: 6.2rem 0 10rem;
  }
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  &:first-of-type {
    margin-top: 72px;
  }

  & p {
    margin-top: 18px;
  }
  @media (min-width: 1024px) {
    width: 50%;

    &:first-of-type {
      margin-right: 5rem;
      margin-top: 0px;
    }
  }
`
const ImgMask = styled.div`
  margin-top: 25px;

  @media (min-width: 768px) {
    max-width: 50vw;
  }
  @media (min-width: 1024px) {
    margin-top: 48px;
    max-width: 100%;
  }
`
